import React, { useMemo } from "react"
import { StyleSheet, Text, View } from "react-native"
import { useMediaQuery } from "react-responsive"

import Base from "../../../base"
import Gap from "../../common/Gap"

export default function TimeSlotHeader(props) {
  const isTablet = useMediaQuery(Base.constants.tablet)

  const timePrefix = useMemo(() => (isTablet ? "" : " Time"), [isTablet])

  return (
    <View style={styles.main}>
      <Text style={styles.textfield}>Start{timePrefix}</Text>
      <View style={[styles.dash, !!isTablet && styles.dash_md]} />
      <Text style={styles.textfield}>End{timePrefix}</Text>
      <Gap size={132} horizontal />
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    height: 30,
  },

  textfield: {
    height: 30,
    flex: 1,
    textAlign: "center",
    fontFamily: Base.fonts.appRegular,
    fontSize: 15,
  },

  dash: {
    width: 50,
  },

  dash_md: {
    width: 30,
  },
})
